import { render, staticRenderFns } from "./formCommentBox.vue?vue&type=template&id=5b96a411&"
import script from "./formCommentBox.vue?vue&type=script&lang=js&"
export * from "./formCommentBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/bhc/flow/formCommentBox.vue"
export default component.exports